export default __webpack_public_path__ + "7e3f762b0c33b5284440448d61ea06fb.png";